(function() {
	"use strict";

	angular.module("swurveys.maker")
		.factory("signupModal", signupModal);

	function signupModal(ModalService, $timeout) {
		return {
			show: function() {
				return ModalService.showModal({
					templateUrl: "app/modals/signup/signup.html",
					controller: ["$element", "$scope", "close", "swurveysStageConfig", function($element, $scope, close, swurveysStageConfig) {

						var poolData = {
							UserPoolId: swurveysStageConfig.getConfigPropertyValue("user_pool_id"),
							ClientId: swurveysStageConfig.getConfigPropertyValue("user_pool_client_id")
						};

						var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);

						var modal = this;
						modal.loginAttempts = 0;
						modal.passwordPlaceholder = "Password";

						this.close = function(args) {
							$(".modal-backdrop")
								.remove();
							close(args, 500);
						};


						var resendConfirmationCode = function(username) {
							username = username.toLowerCase();
							var userData = {
								Username: username,
								Pool: userPool
							};

							var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
							cognitoUser.resendConfirmationCode(function(err, result) {

								if (err && err.code == "InvalidParameterException" && err.message == "User is already confirmed.") {
									$scope.$apply(function() {
										$scope.signinFlipped = true;
									});
									return modal.login(modal.email, modal.password);
								}
								if (err) {

									return $scope.$apply(function() {
										modal.error = err;
									});
								}
								$scope.$apply(function() {
									modal.unverifiedUser = result;
								});
							});
						};

						this.signup = function(email, password, name) {
							delete modal.error;
							if(!email || !password)
							{
								//These are blank OR invalid. In either case, HTML5 validation will yell at the user, so just return
								return;
							}
							email = email.toLowerCase();

							var attributeList = [];

							var dataEmail = {
								Name: 'email',
								Value: email
							};
							var dataName = {
								Name: 'name',
								Value: name
							};
							var attributeEmail = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail);
							var attributeName = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataName);

							attributeList.push(attributeEmail);
							attributeList.push(attributeName);
							userPool.signUp(email, password, attributeList, null, function(err, result) {
								if (err && err.code == "UsernameExistsException") {
									return resendConfirmationCode(email);
								}
								console.log(err);
								if (err) {
									return modal.error = err;
								}
								if (result) {
									modal.unverifiedUser = result.user.getUsername();
									$scope.$apply();
								}
							});
						};

						modal.forgotPassword = function() {
							modal.email = modal.email.toLowerCase();
							var userData = {
								Username: modal.email,
								Pool: userPool
							};
							var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

							cognitoUser.forgotPassword({
								onSuccess: function(result) {
									console.log("Password changed successfully");
									modal.login(modal.email, modal.password);
								},
								onFailure: function(err) {
									return modal.error = err;
								},
								inputVerificationCode: function(data) {
									var cb = this;
									$timeout(function() {
										modal.recoveryDestination = data.CodeDeliveryDetails.Destination;
										delete modal.password;
										modal.loginAttempts = 0;
										modal.passwordPlaceholder = "NEW Password";
										modal.confirmForgotPassword = function(code, password) {
											cognitoUser.confirmPassword(code, password, cb);
										};
									});
								}
							});

						};


						modal.login = function(username, password) {
							delete modal.error;
				            if(!username || !password)
							{
								//These are blank OR invalid. In either case, HTML5 validation will yell at the user, so just return
								return;
							}
							username = username.toLowerCase();

							var authenticationData = {
								Username: username,
								Password: password,
							};
							var authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
							var userData = {
								Username: username,
								Pool: userPool
							};
							var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
							cognitoUser.authenticateUser(authenticationDetails, {
								onSuccess: function(result) {
									modal.close(cognitoUser, 500);
								},

								onFailure: function(err) {
									$timeout(function() {
										if (err.code == "NotAuthorizedException") {
											modal.loginAttempts++;
										}
										if (err.code == "UserNotConfirmedException") {
											$scope.signinFlipped = false;
											return resendConfirmationCode(username);
										}
										modal.error = err;
										console.log(err);
									});
								},

							});

						};

						this.verify = function(verifyCode) {
							delete modal.error;
							modal.email = modal.email.toLowerCase();
							var userData = {
								Username: modal.email,
								Pool: userPool
							};

							var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

							cognitoUser.confirmRegistration(verifyCode, true, function(err, result) {
								if (err) {
									return $scope.$apply(function() {
										modal.error = err;
									});
								}
								if (result == "SUCCESS") {
									$scope.$apply(function() {
										$scope.signinFlipped = true;
									});
									return modal.login(modal.email, modal.password);
								}
							});
						};
					}],
					controllerAs: "modal"
				});
			}
		};

	}
}());
